import {
  FilterId,
  FilterOptionsType,
  MultiSelectListFilter,
} from 'uplisting-frontend/utils/filters/abstract';

export enum AirbnbQualityState {
  good = 'GOOD',
  educate = 'EDUCATE',
  warn = 'WARN',
  probation = 'PROBATION',
  additional_warn = 'ADDITIONAL_WARN',
  pending_removal = 'PENDING_REMOVAL',
  suspended = 'SUSPENDED',
  removed = 'REMOVED',
}

export class AirbnbQualityStateFilter extends MultiSelectListFilter {
  id = FilterId.airbnbQualityState;
  optionsType = FilterOptionsType.list;
  optionsList = [
    AirbnbQualityState.good,
    AirbnbQualityState.educate,
    AirbnbQualityState.warn,
    AirbnbQualityState.probation,
    AirbnbQualityState.additional_warn,
    AirbnbQualityState.pending_removal,
    AirbnbQualityState.suspended,
    AirbnbQualityState.removed,
  ];
}
